import React, { useRef } from 'react';
import { useClassName, useWindowSize } from 'common/hooks';
import './get-your-tickets-block.less';
import {
  getContentfulAssetUrlandAlt,
  getContentfulField,
} from 'common/components';
import { Button } from 'common/lazy';
import { AnimatedText } from '../AnimatedText/AnimatedText';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import useCustomStyle from 'public/screens/CustomLandingPage/hooks';
// import { VerticalScrollCarousel } from './VerticalScrollCarousel/VerticalScrollCarousel';

export const GetYourTicketsBlock = ({ venue }) => {
  const className = useClassName('GetYourTicketsBlock');
  const containerRef = useRef(null);
  const tertiaryColor = getContentfulField(venue.parkScreen?.tertiaryColor);
  const getYourTickets = getContentfulField(venue.parkScreen?.getYourTickets);
  const getYourTicketsBlock = getContentfulField(
    venue.parkScreen?.getYourTicketsBlock
  );
  const settings = getContentfulField(getYourTickets?.fields.settings);
  const description = settings.find(
    (setting) => getContentfulField(setting.fields.key) === 'description'
  );
  const descriptionValue = description
    ? getContentfulField(description?.fields.richTextValue)
    : null;
  const petFields = getContentfulField(
    venue.parkScreen.getYourTicketsPet
  ).fields;
  const pet = {
    desktop: getContentfulAssetUrlandAlt(petFields.desktop),
    mobile: getContentfulAssetUrlandAlt(petFields.mobile),
  };
  // const slides = getContentfulField(getYourTickets?.fields.slides).map(
  //   (slide) => ({
  //     desktop: getContentfulAssetUrlandAlt(slide.fields.desktop),
  //     mobile: getContentfulAssetUrlandAlt(slide.fields.mobile),
  //   })
  // );

  // const processedSlides = React.useMemo(() => {
  //   return slides.map((slide, index) => {
  //     // Random size between 250px and 450px
  //     const size =
  //       index % 2 === 0
  //         ? Math.floor(Math.random() * (350 - 250)) + 250
  //         : Math.floor(Math.random() * (450 - 350)) + 350;

  //     // Random X offset (negative shifts left, positive shifts right)
  //     // Range: -100px to 100px roughly, or maybe wider?
  //     // User said "posiciones random de X".
  //     const xOffset =
  //       index % 2 === 0
  //         ? Math.floor(Math.random() * 125) - 250
  //         : Math.floor(Math.random() * 125) - 125;

  //     // Random Y offset (small)
  //     // Range: -30px to 30px
  //     const yOffset = Math.floor(Math.random() * 60) - 30;

  //     return {
  //       ...slide,
  //       size,
  //       xOffset,
  //       yOffset,
  //     };
  //   });
  // }, [slides]);

  const rawSettings =
    getContentfulField(getYourTicketsBlock?.fields?.settings) || [];
  const processedSettings = rawSettings.map((setting) => ({
    ...setting,
    fields: {
      key: getContentfulField(setting.fields.key),
      name: getContentfulField(setting.fields.name),
      value: getContentfulField(setting.fields.value),
      mobileValue: getContentfulField(setting.fields.mobileValue),
      tabletValue: getContentfulField(setting.fields.tabletValue),
      desktopValue: getContentfulField(setting.fields.desktopValue),
    },
  }));

  const [, style] = useCustomStyle(processedSettings);

  const { isTablet, isMobile } = useWindowSize();
  const getYourTicketsBackground = getContentfulField(
    getYourTicketsBlock?.fields.asset
  );

  const image = isMobile
    ? getYourTicketsBackground.fields.mobile
    : isTablet
    ? getYourTicketsBackground.fields.tablet
    : getYourTicketsBackground.fields.desktop;
  const imageToUse = getContentfulAssetUrlandAlt(image);

  const petStyle = Object.fromEntries(
    Object.entries(style)
      .filter(([k]) => k.startsWith('--logo-'))
      .map(([k, v]) => [k.replace('--logo-', ''), v])
  );

  const containerStyle = Object.fromEntries(
    Object.entries(style)
      .filter(([k]) => k.startsWith('--container-'))
      .map(([k, v]) => [k.replace('--container-', ''), v])
  );

  const backgroundStyle = Object.fromEntries(
    Object.entries(style)
      .filter(([k]) => k.startsWith('--background-'))
      .map(([k, v]) => [k.replace('--background-', ''), v])
  );

  return (
    <div
      ref={containerRef}
      className={className('container')}
      style={{ backgroundColor: tertiaryColor }}>
      {/* <VerticalScrollCarousel
        images={processedSlides}
        // Base width/height can still be passed but might be overridden per item
        width={isMobile ? 160 : 250}
        height={isMobile ? 160 : 250}
        gap={isMobile ? 40 : 20}
      /> */}

      <div className={className('inner')} style={containerStyle}>
        <img
          src={imageToUse.assetUrl}
          alt={imageToUse.assetAlt}
          className={className('background')}
          style={backgroundStyle}
        />

        <div className={className('pet')} style={petStyle}>
          <img src={pet.desktop.assetUrl} alt={pet.desktop.assetAlt} />
        </div>

        <div className={className('text-content')}>
          <h2 className={className('text-content__title')}>
            <AnimatedText
              text={getContentfulField(getYourTicketsBlock.fields.title)}
            />
          </h2>
          <div className={className('text-content__description')}>
            {documentToReactComponents(descriptionValue)}
          </div>
          <Button
            href={`/venue/${venue.slug}/tickets`}
            primary
            className={className('text-content__cta')}>
            Buy Tickets
          </Button>
        </div>
      </div>
    </div>
  );
};
